export const getCurrentOnboardingVariant = (
  optimizeVariantId: string,
): string => `ab_variant_${optimizeVariantId}`
